import { getUserData } from './API';

/**
 * Returns true when the current user's district is in BTS ("Back To School") mode.
 *
 * Mirrors the Amira Educators Client gate (selectIsBTSEffective), adapted to this app's
 * singleton userData store instead of a Redux selector. License-only by product decision
 * (ASSMNT-1702): an explicit `evaluarBTS === true` turns BTS on; `false` (kill switch) or
 * an unset/null value (unlicensed) turns it off. There is intentionally no feature-flag
 * fallback and no Evaluar-pilot consideration.
 *
 * The only BTS-gated feature today is routing Spanish (es-mx) assessments through AOS
 * (see shouldUseAOS in util.js).
 */
export function isBTSEffective() {
  return getUserData().evaluarBTS === true;
}
